import { useTranslation } from 'react-i18next';
import { ActivityFlash } from '@/shared/MotionWrappers';
import { useAppStore } from './appStore';

export function ActivityStrip() {
  const { t } = useTranslation('common');
  const lastAction = useAppStore((s) => s.lastAgentAction);

  return (
    <ActivityFlash
      active={Boolean(lastAction)}
      className="flex h-7 items-center justify-between border-t border-border bg-card px-3 text-xs text-muted-foreground"
    >
      <span className="truncate">
        {lastAction
          ? lastAction.description
          : t('activity.idle', { defaultValue: 'Ready.' })}
      </span>
      {lastAction && (
        <span className="font-mono text-[10px]">
          {t('activity.correlation', {
            defaultValue: 'corr: {{id}}',
            id: lastAction.correlationId,
          })}
        </span>
      )}
    </ActivityFlash>
  );
}
